// SearchHeader.jsx
import React, { useEffect, useState } from 'react';
import { IoMdNotificationsOutline } from "react-icons/io";
import { FaArrowRight } from "react-icons/fa6";
import { DateTime } from "luxon";
import axiosInstance from "../../lib/axiosInstance";

import './Header.css';

const Header = ({ branches = [], selectedBranchId = "", onBranchChange }) => {
    const [scheduledCount, setScheduledCount] = useState(null);
    const tz = process.env.REACT_APP_CLINIC_TZ || "Asia/Kolkata";

    useEffect(() => {
        let mounted = true;
        async function loadScheduled() {
            try {
                const today = DateTime.now().setZone(tz);
                const date = today.toISODate(); // YYYY-MM-DD
                const dateFrom = DateTime.fromISO(date, { zone: tz }).startOf("day").toUTC().toISO();
                const dateTo = DateTime.fromISO(date, { zone: tz }).endOf("day").toUTC().toISO();
                if (!selectedBranchId) {
                    if (mounted) setScheduledCount(0);
                    return;
                }
                const res = await axiosInstance.get("/appointments", { params: { branchId: selectedBranchId, dateFrom, dateTo, status: "scheduled" } });
                const d = res && res.data ? res.data : res;
                const total = (d && typeof d.total === "number") ? d.total : (Array.isArray(d) ? d.length : 0);
                if (mounted) setScheduledCount(total);
            } catch (err) {
                console.error("load scheduled count failed", err);
                if (mounted) setScheduledCount(0);
            }
        }
        loadScheduled();
        return () => { mounted = false; };
    }, [selectedBranchId, tz]);

    const todayLabel = DateTime.now().setZone(tz).toLocaleString(DateTime.DATE_MED);
    const goToAppointments = () => {
        window.history.pushState({}, "", "/appointments");
        window.dispatchEvent(new PopStateEvent("popstate"));
    };

    return (
        <div className="header">
            <div className='header-btns'>
                <select
                    value={selectedBranchId || ""}
                    onChange={(e) => onBranchChange && onBranchChange(e.target.value)}
                    style={{ padding: "8px 10px", borderRadius: 8, border: "1px solid #d1d5db", marginRight: 8 }}
                >
                    <option value="" disabled>Select branch</option>
                    {branches.map((b) => (
                        <option key={b._id || b.id} value={b._id || b.id}>
                            {b.name}
                        </option>
                    ))}
                </select>
                <div className="bookings-badge" title="Scheduled appointments for today" onClick={goToAppointments}>
                <span className="arrow"><FaArrowRight/></span>

                    <span className="dot" /> {scheduledCount == null ? "x" : scheduledCount} pending
                </div>
                <div className='notif-icon' title="Notifications">
                    <IoMdNotificationsOutline />
                    {typeof scheduledCount === "number" && scheduledCount > 0 && (
                        <span className="notif-badge" aria-label={`${scheduledCount} pending`}>
                            {scheduledCount > 99 ? "99+" : scheduledCount}
                        </span>
                    )}
                </div>
                <div className="date">Today, {todayLabel}</div>
            </div>
        </div>
    );
};

export default Header;
